import { Component, Input, Output, EventEmitter } from '@angular/core';
import {InfluencerCampaign} from '../../../../models/influencer-campaign';
import { EventTrackerService, UserActionType, Page, TargetType } from '../../../services/event-tracker/event-tracker.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'campaign-influencers-list',
  templateUrl: './campaign-influencers-list.component.html',
  styleUrls: ['./campaign-influencers-list.component.scss']
})
export class CampaignInfluencersListComponent {

  @Input()
  isShow: boolean;
  @Input()
  campaignId: number;

  @Input()
  isCampaignDetails = false;

  @Input()
  emptyListMessage: string;

  @Input()
  influencerList: InfluencerCampaign[] = [];

  @Input()
  campaignName: string;

  @Input()
  isCampaignInfluencerDetails: boolean;

  @Input()
  campaignTotalPost: number;

  @Output()
  goToCampaignDetails = new EventEmitter<any>();

  private activeAccount: string;

  constructor(private eventTracker: EventTrackerService,
              private router: Router,
              private userService: UserService,
              private activatedRoute: ActivatedRoute) {}

  viewAllInfluencer() {
    this.sendMixpanelEvent();
    this.goToCampaignDetails.emit();
  }

  private sendMixpanelEvent() {
    this.eventTracker.trackUserAction(UserActionType.VIEW, Page.CAMPAIGN_DETAILS, {
      id: this.campaignId,
      name: this.campaignName,
      type: TargetType.CAMPAIGN
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/main/campaigns/campaign-influencers-list/campaign-influencers-list.component.ts